import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: '',
    main: [
      {
        state: 'dashboard',
        short_label: 'D',
        name: 'Indicateurs',
        type: 'sub',
        icon: 'ti-home',
        children: [
          {
            state: 'default',
            name: 'Tableau de bord'
          }/*,
          {
            state: 'ecommerce',
            name: 'Par pôle'
          },
          {
            state: 'crm',
            name: 'Par direction'
          },
          {
            state: 'project',
            name: 'Project'
          }*/
        ]
      },
        /*{
            state: 'widget',
            short_label: 'W',
            name: 'Réunions',
            type: 'sub',
            icon: 'ti-user',
            children: [
                {
                    state: 'static',
                    name: 'Types de réunion'
                },
                {
                    state: 'static',
                    name: 'Réunions direction'
                },
                {
                    state: 'static',
                    name: 'Réunions pôle'
                },
                {
                    state: 'static',
                    name: 'Toutes les réunions'
                }
            ]
        },*/
        {
            state: 'projet',
            short_label: 'P',
            name: 'Projets',
            type: 'sub',
            icon: 'ti-bag',
            children: [
                {
                    state: 'liste',
                    name: 'Mes projets'
                },
                {
                    state: 'projetspardirection',
                    name: 'Projets direction'
                },
                {
                    state: 'projetsparpole',
                    name: 'Projets pôle'
                },
                {
                    state: 'touslesprojets',
                    name: 'Tous les projets'
                }
            ]
        },
        {
            state: 'tache',
            short_label: 'T',
            name: 'Tâches',
            type: 'sub',
            icon: 'ti-check-box',
            children: [
                {
                    state: 'board',
                    name: 'Tableau de bord'
                },
                {
                    state: 'list',
                    name: 'Les tâches'
                }
            ]
        },
        {
            state: 'ged',
            short_label: 'G',
            name: 'GED',
            type: 'sub',
            icon: 'ti-files',
            children: [
                {
                    state: 'liste',
                    name: 'Documents des projets'
                },
                {
                    state: 'reunion',
                    name: ' Documents des réunions'
                }
            ]
        },
        {
            state: 'administration',
            short_label: 'A',
            name: 'Administration',
            type: 'sub',
            icon: 'ti-settings',
            children: [
                /*{
                    state: 'actions',
                    name: 'Actions'
                },*/
                {
                    state: 'directions',
                    name: 'Directions'
                },
                {
                    state: 'fonctions',
                    name: 'Fonctions'
                },
                /*{
                    state: 'modules',
                    name: 'Modules'
                },*/
                {
                    state: 'pole',
                    name: 'Pôles'
                },
                {
                    state: 'profils',
                    name: 'Profils'
                },
                {
                    state: 'utilisateur',
                    name: 'Utilisateurs'
                }
            ]
        }
    ],
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/shared/menu-items/menu-items.ts